/* Header dropdowns: click / tap / keyboard. Works for desktop menus and the mobile menu. */
(function () {
  var SEL = '[data-dd]';
  function list(b) { return document.getElementById(b.getAttribute('aria-controls')); }
  function setOpen(b, open) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); var l = list(b); if (l) l.hidden = !open; }
  function closeAll(except) {
    document.querySelectorAll(SEL).forEach(function (b) { if (b !== except && b.getAttribute('aria-expanded') === 'true') setOpen(b, false); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest(SEL);
    if (b) { var was = b.getAttribute('aria-expanded') === 'true'; closeAll(b); setOpen(b, !was); return; }
    if (e.target.closest('.dd__list a')) closeAll();
  });
  document.addEventListener('pointerdown', function (e) { if (!e.target.closest('.dd')) closeAll(); });
  document.addEventListener('keydown', function (e) {
    var dd = e.target.closest && e.target.closest('.dd');
    if (e.key === 'Escape') {
      var b = dd ? dd.querySelector(SEL) : document.querySelector(SEL + '[aria-expanded="true"]');
      if (b && b.getAttribute('aria-expanded') === 'true') { setOpen(b, false); b.focus(); }
    } else if (e.key === 'ArrowDown' && e.target.matches && e.target.matches(SEL)) {
      e.preventDefault(); closeAll(e.target); setOpen(e.target, true);
      var first = list(e.target).querySelector('a'); if (first) first.focus();
    }
  });
  document.addEventListener('focusout', function (e) {
    var dd = e.target.closest && e.target.closest('.dd'); if (!dd) return;
    setTimeout(function () { if (!dd.contains(document.activeElement)) { var b = dd.querySelector(SEL); if (b) setOpen(b, false); } }, 0);
  });
})();

/* Mobile menu: close when tapping outside it or pressing Escape */
(function () {
  document.addEventListener('click', function (e) {
    var m = document.querySelector('.mnav');
    if (m && m.open && !m.contains(e.target)) m.open = false;
  });
  document.addEventListener('keydown', function (e) {
    var m = document.querySelector('.mnav');
    if (e.key === 'Escape' && m && m.open) { m.open = false; var s = m.querySelector('summary'); if (s) s.focus(); }
  });
})();
